import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import { Button, Badge, Tooltip, OverlayTrigger, Row, Col, Tab, Nav } from "react-bootstrap";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';

import Add from '../../../modal/Lead_Management/Manage_Coupon/AddRedeem';
import Edit from '../../../modal/Lead_Management/Manage_Coupon/EditRedeem';
import View from '../../../modal/Lead_Management/Manage_Coupon/ViewCoupon';

import axios from 'axios';
import moment from 'moment';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingComponent from '../../../layouts/nav/loading';
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const Redeem = () => {
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

    const defaultPermissions = {
        view_dashboard: 0,
        branch_man: 0,


        // ---------------------- lead ---------------
        lead_man: 0,
        man_lead: 0,
        lead_list: 0,
        lead_add: 0,
        lead_edit: 0,
        lead_followup: 0,
        lead_view: 0,
        lead_import: 0,
        lead_export: 0,
        lead_subscribe: 0,
        lead_approve_spam: 0,
        lead_approve_dead: 0,

        man_coupon: 0,
        coupon_list: 0,
        coupon_add: 0,
        coupon_edit: 0,
        coupon_view: 0,
        points_add: 0,
        points_edit: 0,

        man_followup: 0,
        followup_list: 0,

        man_calls: 0,
        calls_list: 0,
        calls_location: 0,
        calls_add_lead: 0,

        lead_calender: 0,
        calender_list: 0,

        lead_source: 0,
        source_list: 0,

        // -------------------------------- team ---------------------
        team_man: 0,
        team_lead: 0,
        team_lead_list: 0,
        team_followup: 0,
        team_followup_list: 0,
        team_calls: 0,
        team_calls_list: 0,
        team_promise: 0,
        promise_month_list: 0,
        promise_today_list: 0,

        subscri_man: 0,
        subscriber_list: 0,
        subscriber_view: 0,
        subscriber_edit: 0,
        subscriber_filter: 0,
        subscriber_new_subscription: 0,
        subscriber_drop_subscription: 0,

    };

    // Immediately load from localStorage if available
    const initialPermissions = (() => {
        const stored = localStorage.getItem('user_permissions');
        return stored ? JSON.parse(stored) : defaultPermissions;
    })();

    const [permissions, setPermissions] = useState(initialPermissions);
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [total_coupon, settotalCoupon] = useState(0);
    const [total_redeem, settotalRedeem] = useState(0);

    const fetchcount = () => {
        const params = {
            branch_id: branch_id
        };
        axios.get(`${baseURL}/redeem/counts`, { params: params })
            .then(response => {
                settotalCoupon(response.data.coupon_count);
                settotalRedeem(response.data.redeem_count);
            })
            .catch(error => {
                console.error('There was an error fetching the posts!', error);
            });
    }

    useEffect(() => {
        fetchcount();
    }, []);

    const [datas, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    const [loading, setLoading] = useState(false);

    // Pagination
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [perPage, setPerPage] = useState(25);

    const fetchData = () => {
        setLoading(true);
        axios.get(`${baseURL}/redeem`, {
            params: {
                page,
                per_page: perPage,
                search: searchTerm,
                branch_id: branch_id
            }
        }).then(response => {
            setData(response.data.data);
            setHasFetched(true);
            setLoading(false);
        }).catch(error => {
            console.log('There was an error fetching the data!', error);
            setHasFetched(true);
            setLoading(false);
        });
    };

    // table data fetch
    useEffect(() => {
        fetchData();
    }, [page, searchTerm, perPage]);


    const [selectedId, setSelecctedID] = useState({});
    const tableRef = useRef(null);

    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);
    const handleModalToggle = () => {
        setModalType("Add");
        setOpen(true);
    };

    const handleModalToggle_Edit = (selectedId) => {
        setSelecctedID(selectedId);
        setModalType("Edit");
        setOpen(true);
    };

    const handleStatusToggle = async (id, currentStatus) => {
        const newStatus = currentStatus === 0 ? 1 : 0;
        axios.put(`${baseURL}/redeem/status/${id}`, { status: newStatus })
            .then(response => {
                // window.location.reload();
                toast.success("Status Updated successfully!");
            })
            .catch(error => {
                console.log(error);
                toast.error("Status Updation Failed");
            });
    };

    useEffect(() => {
        if (hasFetched) {
            if (tableRef.current) {
                if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                    $(tableRef.current).DataTable({
                        "responsive": true,
                        pageLength: 25,
                        //   "aaSorting": [],
                        "ordering": false,
                        "language": {
                            "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                        },
                        "dom":
                            "<'row'" +
                            "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                            "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                            ">" +
                            "<'table-responsive'tr>" +
                            "<'row'" +
                            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                            "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                            ">"
                    });
                }
            }
        }
    }, [hasFetched]);

    const softRefresh = () => {
        setHasFetched(false);
        if ($.fn.dataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        fetchData();
    }

    const [key, setKey] = useState('redeem');
    const [isMaintenance, setIsMaintenance] = useState(false);

    useEffect(() => {
        let isMounted = true;

        const checkMaintenanceStatus = async () => {
            try {
                const response = await axios.get(`${baseURL}/maintenance-mode?branch_id=${branch_id}`);
                const data = response.data.data || [];
                const branchStatus = data.find((item) => item.slug === "managecoupon"); // use managebranch slug

                if (isMounted) {
                    setIsMaintenance(branchStatus?.maintenancemode_status === 1);
                }
            } catch (error) {
                console.error("Error checking maintenance mode:", error);
                if (isMounted) setIsMaintenance(false);
            } finally {
                if (isMounted) setLoading(false);
            }
        };

        checkMaintenanceStatus();

        return () => {
            isMounted = false;
        };
    }, [baseURL, branch_id]);

    if (isMaintenance) {
        return (
            <div
                className="d-flex flex-column align-items-center justify-content-center text-center"
                style={{ height: "100vh", width: "100vw" }}
            >
                <h1 className="text-warning mb-3">🚧 Under Maintenance</h1>
                <p className="text-muted fs-5">
                    The <strong>Manage Coupon </strong> module is currently under maintenance. <br />
                    Please check back later.
                </p>
            </div>
        );
    }

    return (
        <>
            {loading ? (
                <div className="d-flex align-items-center justify-content-between flex-wrap page-titles px-0 py-1 mx-0">
                    <div className='mb-2'>
                        <div className="mb-0 px-0">
                            <h4 style={{ color: '#025d3a' }}><Skeleton width={150} /></h4>
                        </div>
                        <ol className="breadcrumb fs-7">
                            <li className="breadcrumb-item"><Skeleton width={70} /></li>
                            <li className="breadcrumb-item"><Skeleton width={20} /></li>
                            <li className="breadcrumb-item active"><Skeleton width={100} /></li>
                        </ol>
                    </div>
                    <div className='d-flex align-items-center gap-3 flex-wrap mb-2'>
                        <Skeleton width={150} height={30} borderRadius={10} />
                    </div>
                </div>
            ) : (
                <div className="d-flex align-items-center justify-content-between flex-wrap page-titles px-0 py-1 mx-0">
                    <div className='mb-2'>
                        <div className="mb-0 px-0">
                            <h4 style={{ color: '#025d3a' }}>Manage Coupon</h4>
                        </div>
                        <ol className="breadcrumb fs-7">
                            <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                            <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                            <li className="breadcrumb-item active">Lead Management</li>
                        </ol>
                    </div>

                    {permissions.points_add === 1 && (
                        <div className='d-flex align-items-center gap-3 flex-wrap mb-2'>
                            <Link to={"#"} className="btn btn-primary float-end btn-sm" onClick={handleModalToggle}>
                                <span className='me-2'><i className="fa-solid fa-plus fs-8"></i></span>
                                <span className=''>Add Redeem Points</span>
                            </Link>
                        </div>
                    )}

                    {open && modalType === "Add" && (
                        <Add show={open} onClose={() => setOpen(false)} refresh={softRefresh} />
                    )}
                    {open && modalType === "Edit" && (
                        <Edit show={open} onClose={() => setOpen(false)} data={selectedId} refresh={softRefresh} />
                    )}
                    {/* {open && modalType === "View" && (
                    <View show={open} onClose={() => setOpen(false)} selectedId={selectedId} />
                )} */}

                </div>
            )}

            {permissions.coupon_list === 1 && (
                <>
                    {loading ? (
                        <Col xl={12} className='mb-3'>
                            <div className="custom-tab-1">
                                <Nav as="ul" className="nav-tabs">
                                    {[1, 2].map((_, index) => (
                                        <Nav.Item as="li" key={index}>
                                            <Nav.Link disabled className="d-flex align-items-center">
                                                <Skeleton circle width={20} height={20} />

                                                <div className="ms-2">
                                                    <Skeleton width={80} height={14} />
                                                </div>

                                                <div className="ms-2">
                                                    <Skeleton width={30} height={18} borderRadius={12} />
                                                </div>
                                            </Nav.Link>
                                        </Nav.Item>
                                    ))}
                                </Nav>
                            </div>
                        </Col>
                    ) : (
                        <Col xl={12} className='mb-3'>
                            <div className="custom-tab-1">
                                <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
                                    <Nav as="ul" className="nav-tabs">
                                        <Nav.Item as="li" >
                                            <Nav.Link as={Link} to="/manage-coupon">
                                                <i className="fa-solid fa-tags"></i>
                                                <label className="ms-2 fs-6">
                                                    Coupon
                                                </label>
                                                <Badge as="a" href="" bg=" badge-circle" className='badge-outline-success ms-2 fw-bold fs-8'>
                                                    {total_coupon}
                                                </Badge>
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item as="li" >
                                            <Nav.Link eventKey="redeem">
                                                <i className="fa-solid fa-coins"></i>
                                                <label className="ms-2 fs-6">
                                                    Redeem Points
                                                </label>
                                                <Badge as="a" href="" bg=" badge-circle" className='badge-outline-warning ms-2 fw-bold fs-8'>
                                                    {total_redeem}
                                                </Badge>
                                            </Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Tab.Container>
                            </div>
                        </Col>
                    )}
                </>
            )}

            {permissions.coupon_list === 1 && (
                <>
                    {loading ? (
                        <div className="table-container">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                {/* Left: Show entries dropdown */}
                                <div>
                                    <label className="me-2"><Skeleton width={50} height={25} /></label>
                                    <Skeleton width={50} height={25} className="mb-1" />
                                </div>

                                {/* Right: Search input */}
                                <div>
                                    <Skeleton width={150} height={25} className="mb-1" />
                                </div>
                            </div>

                            <table style={{ borderBottom: '2px solid #ddd' }} id="kt_datatable_responsive_approved" className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                <thead>
                                    <tr>
                                        <th><Skeleton width={100} height={16} /></th>
                                        <th><Skeleton width={100} height={16} /></th>
                                        <th><Skeleton width={100} height={16} /></th>
                                        <th><Skeleton width={100} height={16} /></th>
                                        <th><Skeleton width={100} height={16} /></th>
                                        <th><Skeleton width={100} height={16} /></th>
                                    </tr>
                                </thead>
                                <tbody className="text-gray-600 fw-semibold fs-7">
                                    {[...Array(perPage)].map((_, i) => (
                                        <tr key={i}>
                                            <td><Skeleton /></td>
                                            <td><Skeleton /></td>
                                            <td><Skeleton /></td>
                                            <td><Skeleton /></td>
                                            <td><Skeleton /></td>
                                            <td><Skeleton /></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                            <div className="d-flex justify-content-between align-items-center mt-3">
                                {/* Bottom left: Showing x to y of z entries */}
                                <div>
                                    <Skeleton width={180} height={15} />
                                </div>

                                {/* Bottom right: Pagination */}
                                <nav>
                                    <div className="d-flex gap-2">
                                        {[...Array(4)].map((_, i) => (
                                            <Skeleton key={i} width={40} height={25} borderRadius={5} />
                                        ))}
                                    </div>
                                </nav>
                            </div>
                        </div>
                    ) : (
                        <div className="table-container">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                {/* Left: Show entries dropdown */}
                                <div>
                                    <label className="me-2">Show</label>
                                    <select
                                        className="form-select d-inline w-auto"
                                        style={{ fontSize: '0.85rem', height: '30px' }}
                                        value={perPage}
                                        onChange={(e) => {
                                            setPerPage(Number(e.target.value));
                                            setPage(1); // Reset to first page
                                        }}
                                    >
                                        <option value={10}>10</option>
                                        <option value={25}>25</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                    </select>
                                </div>

                                {/* Right: Search input */}
                                <div>
                                    <input
                                        type="text"
                                        style={{ fontSize: '0.85rem', height: '40px' }}
                                        placeholder="Search..."
                                        className="form-control"
                                        value={searchTerm}
                                        onChange={(e) => {
                                            setSearchTerm(e.target.value);
                                            setPage(1); // Reset page on new search
                                        }}
                                    />
                                </div>
                            </div>

                            <table className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable" style={{ borderBottom: '2px solid #ddd' }}>
                                <thead>
                                    <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head align-top">
                                        <th className='min-w-100px'>Points</th>
                                        <th className='min-w-100px'>Redeem Value</th>
                                        <th className='min-w-100px'>Redeem Type</th>
                                        {/* <th className='min-w-100px'>End Date</th> */}
                                        <th className='min-w-50px'>Status</th>
                                        <th className='min-w-50px text-end'>Actions</th>
                                    </tr>
                                </thead>
                                <tbody className="text-gray-600 fw-semibold fs-7 align-top">
                                    {datas.length === 0 && hasFetched ? (
                                        <tr>
                                            <td colSpan="5" className="text-center text-muted py-2">
                                                No data available
                                            </td>
                                        </tr>
                                    ) : (
                                        <>
                                            {datas.map((data, index) => (
                                                <tr key={data.sno}>
                                                    <td>
                                                        <div className='text-black font-w400 fs-7 text-wrap mw-75'>{data.points}</div>
                                                    </td>
                                                    <td>
                                                        <div className='text-black font-w400 fs-7 text-wrap mw-75'>{data.value}</div>
                                                    </td>
                                                    <td>
                                                        <div>
                                                            <Badge bg="info" className='text-white fs-7 py-0 px-1'>{data.value_type == 0 ? 'Amount' : 'Percentage'}</Badge>
                                                        </div>
                                                    </td>
                                                    {/* <td>
                                                <div className='text-danger font-w600 fs-7'>{moment(data.enddate).format('DD-MMM-YYYY')}</div>
                                            </td> */}
                                                    <td>
                                                        <div className="form-check form-switch d-flex align-items-center mb-3">
                                                            <input className="form-check-input me-2" type="checkbox" role="switch" defaultChecked={data.status === 0} onChange={() => handleStatusToggle(data.sno, data.status)} disabled={permissions.points_edit !== 1} />
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="text-end">

                                                            {/* <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>View</span></Tooltip>} >
                                                        <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleModalToggle_view(data.sno)}>
                                                            <span><i className="fa-solid fa-eye fs-5 mt-1"></i></span>
                                                        </Button>
                                                    </OverlayTrigger> */}

                                                            {permissions.points_edit === 1 && (
                                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Edit</span></Tooltip>} >
                                                                    <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleModalToggle_Edit(data)}>
                                                                        <span><i className="fa-solid fa-pen-to-square fs-5 mt-1"></i></span>
                                                                    </Button>
                                                                </OverlayTrigger>
                                                            )}

                                                        </div>

                                                        {permissions.points_edit != 1 && (
                                                            <div className="text-end">
                                                                No Actions
                                                            </div>
                                                        )}

                                                    </td>
                                                </tr>
                                            ))}
                                        </>
                                    )}
                                </tbody>
                            </table>

                            <div className="d-flex justify-content-between align-items-center mt-3">
                                {/* Bottom left: Showing x to y of z entries */}
                                <div>
                                    {datas.length > 0 ? (
                                        <span className="text-muted">
                                            Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + datas.length} of {totalPages * perPage - (perPage - datas.length)} entries
                                        </span>
                                    ) : (
                                        <span className="text-muted">
                                            Showing 0 to 0 of 0 entries
                                        </span>
                                    )}
                                </div>

                                {/* Bottom right: Pagination */}
                                <nav>
                                    <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                        <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                                        </li>
                                        {[...Array(totalPages)].map((_, i) => (
                                            <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                                            </li>
                                        ))}
                                        <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                            <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                                        </li>
                                    </ul>
                                </nav>

                            </div>
                        </div>
                    )}
                </>
            )}

            {permissions.coupon_list === 0 && (
                <div className='align-content-center' style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingTop: '10%',
                    // height: '100vh',       // full viewport height
                    color: 'red',          // text-danger equivalent
                    fontSize: '24px',      // increase font size
                    fontWeight: 'bold'     // optional for emphasis
                }}>
                    <label>No Access</label>
                </div>
            )}

        </>
    )


}
export default Redeem;